"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYLOAD_SENSITIVE_GUEST_EVENTS = exports.isProtectedServerGuestEvent = exports.isPublicServerGuestEvent = exports.ProtectedServerGuestEvent = exports.PublicServerGuestEvent = void 0;
var PublicServerGuestEvent;
(function (PublicServerGuestEvent) {
    PublicServerGuestEvent["cancelReservation"] = "cancelReservation";
    PublicServerGuestEvent["createFeedback"] = "createFeedback";
    PublicServerGuestEvent["createReservation"] = "createReservation";
    PublicServerGuestEvent["deleteReservation"] = "deleteReservation";
    PublicServerGuestEvent["getSearchSuggestions"] = "getSearchSuggestions";
    PublicServerGuestEvent["searchForPlaces"] = "searchForPlaces";
    PublicServerGuestEvent["getAddress"] = "getAddress";
    PublicServerGuestEvent["getFaqAnswers"] = "getFaqAnswers";
    PublicServerGuestEvent["getName"] = "getName";
    PublicServerGuestEvent["getNameByUniqueName"] = "getNameByUniqueName";
    PublicServerGuestEvent["getHours"] = "getHours";
    PublicServerGuestEvent["getPhoneNumber"] = "getPhoneNumber";
    PublicServerGuestEvent["getPlaceDetails"] = "getPlaceDetails";
    PublicServerGuestEvent["getPlaceMenu"] = "getPlaceMenu";
    PublicServerGuestEvent["getPlaceLocalization"] = "getPlaceLocalization";
    PublicServerGuestEvent["getPlacePictures"] = "getPlacePictures";
    PublicServerGuestEvent["getReservations"] = "getReservations";
    PublicServerGuestEvent["getReservation"] = "publicGetReservation";
    PublicServerGuestEvent["getReservationRestriction"] = "getReservationRestriction";
    PublicServerGuestEvent["getDatetimeRestriction"] = "getDatetimeRestriction";
    PublicServerGuestEvent["getAvailableLayoutTypes"] = "getAvailableLayoutTypes";
    PublicServerGuestEvent["registerGuestUser"] = "registerGuestUser";
    PublicServerGuestEvent["authenticateGuestUser"] = "authenticateGuestUser";
    PublicServerGuestEvent["verifyGuestUserToken"] = "verifyGuestUserToken";
    PublicServerGuestEvent["forgotGuestUserPassword"] = "forgotGuestUserPassword";
    PublicServerGuestEvent["resetGuestUserPassword"] = "resetGuestUserPassword";
    PublicServerGuestEvent["activateGuestUserAccount"] = "activateGuestUserAccount";
    PublicServerGuestEvent["changeMailBasedOnToken"] = "changeMailBasedOnToken";
    PublicServerGuestEvent["facebookAuth"] = "facebookAuth";
    PublicServerGuestEvent["guestReservationRequest"] = "guestReservationRequest";
    PublicServerGuestEvent["realTimeReservation"] = "realTimeReservation";
})(PublicServerGuestEvent || (exports.PublicServerGuestEvent = PublicServerGuestEvent = {}));
var ProtectedServerGuestEvent;
(function (ProtectedServerGuestEvent) {
    ProtectedServerGuestEvent["getLoggedInGuestUser"] = "getLoggedInGuestUser";
    ProtectedServerGuestEvent["changeGuestUserPassword"] = "changeGuestUserPassword";
    ProtectedServerGuestEvent["updateGuestUserName"] = "updateGuestUserName";
    ProtectedServerGuestEvent["updateGuestUserPhoneNumber"] = "updateGuestUserPhoneNumber";
    ProtectedServerGuestEvent["updateGuestUserSelectedLanguage"] = "updateGuestUserSelectedLanguage";
    ProtectedServerGuestEvent["updateGuestUserDeletionRequestedAt"] = "updateGuestUserDeletionRequestedAt";
    ProtectedServerGuestEvent["requestGuestUserMailChange"] = "requestGuestUserMailChange";
    ProtectedServerGuestEvent["updateGuestUserProfilePicture"] = "updateGuestUserProfilePicture";
    ProtectedServerGuestEvent["deleteGuestUserProfilePicture"] = "deleteGuestUserProfilePicture";
    ProtectedServerGuestEvent["getUpcomingReservations"] = "getUpcomingReservations";
    ProtectedServerGuestEvent["getPastReservations"] = "getPastReservations";
    ProtectedServerGuestEvent["getReservation"] = "protectedGetReservation";
    ProtectedServerGuestEvent["cancelReservation"] = "authenticatedCancelReservation";
    ProtectedServerGuestEvent["createReservation"] = "authenticatedCreateReservation";
    ProtectedServerGuestEvent["updateReservation"] = "authenticatedUpdateReservation";
    ProtectedServerGuestEvent["addReservationGuest"] = "addReservationGuest";
    ProtectedServerGuestEvent["removeReservationGuest"] = "removeReservationGuest";
    ProtectedServerGuestEvent["getGuestUserInfo"] = "getGuestUserInfo";
})(ProtectedServerGuestEvent || (exports.ProtectedServerGuestEvent = ProtectedServerGuestEvent = {}));
const publicServerGuestEventSet = new Set(Object.values(PublicServerGuestEvent));
const protectedServerGuestEventSet = new Set(Object.values(ProtectedServerGuestEvent));
const isPublicServerGuestEvent = (event) => publicServerGuestEventSet.has(event);
exports.isPublicServerGuestEvent = isPublicServerGuestEvent;
const isProtectedServerGuestEvent = (event) => protectedServerGuestEventSet.has(event);
exports.isProtectedServerGuestEvent = isProtectedServerGuestEvent;
exports.PAYLOAD_SENSITIVE_GUEST_EVENTS = new Set([
    PublicServerGuestEvent.resetGuestUserPassword,
    ProtectedServerGuestEvent.changeGuestUserPassword,
    PublicServerGuestEvent.authenticateGuestUser,
]);
//# sourceMappingURL=ServerGuestEvent.js.map